// CROWN – LIVE ON LOVE | CONFIGURAZIONE DA COMPLETARE PRIMA DEL LANCIO
// Inserire il dominio Shopify e gli ID delle varianti realmente vendibili.
// NON inserire qui chiavi private, password o token segreti.
window.CROWN_CONFIG = {
  shopifyDomain: "kacwyu-4r.myshopify.com", // es. "nomestore.myshopify.com" (non è il dominio pubblico)
  contactEmail: "info@crown-luxury-store.com", // e-mail commerciale per richieste B2B
  productsApproved: false, // true SOLO dopo convalida di capi, prezzi, varianti e giacenze
  variantIds: { // Esempio: "CT-001|M|NERO": "12345678901234"
  }
};

// Public customer-care information. Fill only with approved details.
// Leave blank until the real conditions and contact address are available.
window.CROWN_CONFIG.customerCare = {
  email: "assistenza@crown-luxury-store.com",
  shipping: { it: "", en: "" },
  returns: { it: "", en: "" },
  privacy: { it: "", en: "" },
  contact: { it: "", en: "" }
};

// Provided contact; mailbox delivery has not been verified by this preview.
window.CROWN_CONFIG.seller = {
 legalName: "Crown srl", vat: "00772070157",
 registeredAddress: "Via Vittorio Emanuele II 23, 20122 Milano, Italia",
 phone: "+39 340 068 4130", whatsapp: "+393400684130", italyPhone: "800333555", returnAddress: "Via Vittorio Emanuele II 23, 20122 Milano, Italia"
};
window.CROWN_CONFIG.shipping = {
 logisticsVerified: true,
 usEnabled: false,
 dutiesPrepaidVerified: false,
 checkoutTotalsVerified: false
};
// Enable only after a real HTTPS service durably records declarations and queues receipts.
// API credentials belong on the server, never in these public files.
window.CROWN_CONFIG.returnsService = {
 enabled: false, endpoint: "", receiptRetryEndpoint: ""
};

window.CROWN_CONFIG.productsApproved=false;
